var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"switch"},[_c('ul',{staticClass:"buttons"},[(_vm.existFreepass)?_c('li',{class:{
        active: _vm.isSelect === _vm.optionFreepass,
        button1: !_vm.existPremium && _vm.existFreepass,
        button2: _vm.existPremium && _vm.existFreepass
      },on:{"click":function($event){return _vm.changeList(_vm.optionFreepass)}}},[_vm._m(0)]):_vm._e(),_c('li',{class:{
        active: _vm.isSelect === _vm.optionCoupon,
        border: _vm.existPremium,
        button1:
          (_vm.existPremium && !_vm.existFreepass) ||
          (!_vm.existPremium && _vm.existFreepass),
        button2: _vm.existPremium && _vm.existFreepass
      },on:{"click":function($event){return _vm.changeList(_vm.optionCoupon)}}},[_vm._m(1)]),(_vm.existPremium)?_c('li',{staticClass:"premium",class:{
        button1: _vm.existPremium && !_vm.existFreepass,
        button2: _vm.existPremium && _vm.existFreepass
      },on:{"click":function($event){return _vm.tapPremium()}}},[_vm._m(2),_vm._m(3)]):_vm._e()])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"inner"},[_c('p',{staticClass:"tab"},[_vm._v("フリーパス")])])
},function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"inner"},[_c('p',{staticClass:"tab"},[_vm._v("クーポン")])])
},function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"inner"},[_c('img',{attrs:{"src":require("@/assets/img/coupon/icon_premium.svg")}})])
},function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"inner"},[_c('p',{staticClass:"tab"},[_vm._v("プレミアム")])])
}]

export { render, staticRenderFns }